const urlJoin = require(`url-join`)

const RUNTIME_ENV = (window && window.APP_RUNTIME_ENV_VARIABLES) || {}

const env = {
  ...process.env,
  ...RUNTIME_ENV,
}

const { REACT_APP_ACCOUNTS_ORIGIN, REACT_APP_ACCOUNTS_TOKEN_GETTER } = env

const appEnv = {
  /* Login page */
  REACT_APP_LOGIN_PAGE_URL: urlJoin(REACT_APP_ACCOUNTS_ORIGIN, `./oauth/login`),

  /* Logout page */
  REACT_APP_LOGOUT_PAGE_URL: urlJoin(REACT_APP_ACCOUNTS_ORIGIN, `./logout`),

  /* Refresh token api */
  REACT_APP_REFRESH_TOKEN_URL: urlJoin(
    REACT_APP_ACCOUNTS_TOKEN_GETTER,
    `./code-flow/oauth/refresh_token`,
  ),

  /* Get token by code api */
  REACT_APP_GET_TOKENS_URL: urlJoin(
    REACT_APP_ACCOUNTS_TOKEN_GETTER,
    `./code-flow/access_token`,
  ),

  /* Applications list rest api */
  REACT_APP_APPLICATIONS_REST_API: urlJoin(
    REACT_APP_ACCOUNTS_ORIGIN,
    `./user-api/users/current/applications`,
  ),
}

const finalEnv = {
  ...env,
  ...appEnv,
}

export default finalEnv
